export const PWA_CHROME = Object.freeze({ home: "pwaHome", default: "none" });

export const PWA_LAYOUT = Object.freeze({ topInset: 1, bottomClearance: 16, radioClearance: 32 });

export const PWA_DRAWER = Object.freeze({ width: "min(319px, 80vw)" });

export const chromeFor = (standalone) => (standalone ? PWA_CHROME.default : "full");

const match = (paths = [], hashes = []) => Object.freeze({ paths: Object.freeze(paths), hashes: Object.freeze(hashes) });

export const PWA_BOTTOM_BAR_ITEMS = Object.freeze([
  Object.freeze({ id: "home", path: "home", labelKey: "PWA_BOTTOM_BAR.HOME", match: match(["home"]) }),
  Object.freeze({
    id: "help",
    path: "help",
    labelKey: "PWA_BOTTOM_BAR.HELP",
    match: match(["help", "faq"], ["#help-support", "#call-centre"]),
  }),
  Object.freeze({ id: "services", comingSoon: true, labelKey: "PWA_BOTTOM_BAR.SERVICES", match: match() }),
]);

export const PWA_ACCESS = Object.freeze({
  anonymous: ["login", "change-password", "select-language"],
  deniedRoles: ["CITIZEN"],
});

export const PWA_HEADER = Object.freeze({
  toolBarRoutes: Object.freeze(["home"]),
  welcomeHiddenRoutes: Object.freeze(["edit-profile"]),
});

export const pwaRouteSegment = (pathname = "") => pathname.slice(window.contextPath.length).split("/")[1] ?? "";

// "" is the installed app's entry redirect.
export const isPwaAnonymousRoute = (pathname) => {
  const segment = pwaRouteSegment(pathname);
  return segment === "" || PWA_ACCESS.anonymous.includes(segment);
};

// A matching anchor beats the route, as in the web nav.
export const activeBottomBarItem = ({ pathname, hash = "" }) => {
  const byHash = hash && PWA_BOTTOM_BAR_ITEMS.find((item) => item.match.hashes.includes(hash));
  if (byHash) return byHash.id;
  const segment = pwaRouteSegment(pathname);
  return PWA_BOTTOM_BAR_ITEMS.find((item) => item.match.paths.includes(segment))?.id;
};

export const PWA_ENTRY = Object.freeze({ languagePath: "select-language" });
